/*
 *  ************************************************************************
 *  *  © [2015 - 2024] Quintype Technologies India Private Limited
 *  *  All Rights Reserved.
 *  *************************************************************************
 */
import React from "react";
import { useSelector } from "react-redux";
import { PasswordScreen } from "./password-screen";
import { MobileOtpScreen } from "./otp-screen";
import { SignInScreen } from "./signin-screen";
import { getDarkModeStyle } from "../util";
import get from "lodash/get";

export const SignIn = () => {
  const { currentScreen = "signIn" } = useSelector((state) => get(state, ["login", "signIn"], {}));
  const mode = getDarkModeStyle();

  switch (currentScreen) {
    case "signIn":
      return <SignInScreen mode={mode} />;
    case "otp":
      //otp mobile
      return <MobileOtpScreen mode={mode} />;
    case "password":
      return <PasswordScreen mode={mode} />;
  }
};
